<script setup lang="ts">
import { computed, watchEffect } from 'vue';

const props = defineProps<{
  visibleShow: boolean;
  className?: string;
  imageUrl?: string;
  title?: string;
  text?: string;
  confirmText?: string;
  cancelText?: string;
  confirmDisable?: boolean;
  confirmClick?: () => {};
  cancelClick?: () => {};
  closeClick?: () => {};
}>();

const visible = computed(() => props?.visibleShow);

const emit = defineEmits(['shadow']);

watchEffect(() => {
  emit('shadow', visible.value);
});
</script>

<template>
  <van-popup round :class="`common-popup ${className}`" v-model:show="visible" position="bottom">
    <div
      v-if="imageUrl"
      class="popup-img"
      :style="`background: #EEEEEE url(${imageUrl}) center / 100% no-repeat`"
      @click-overlay="cancelClick"
    />
    <div
      :class="{
        'popup-content': true,
        'only-content': !imageUrl
      }"
    >
      <div v-if="title" class="popup-title">
        {{ title }}
      </div>
      <div v-if="text" class="popup-label">
        {{ text }}
      </div>
      <slot name="content"></slot>
      <div v-if="confirmText" class="popup-confirm" @click="confirmClick">
        {{ confirmText }}
      </div>
      <div v-if="cancelText" class="popup-cancel" @click="cancelClick">
        {{ cancelText }}
      </div>
    </div>
    <div v-if="closeClick" @click="closeClick" class="close-icon"></div>
  </van-popup>
</template>

<style lang="less">
.common-popup {
  .popup-img {
    height: 2.4rem;
  }

  .popup-content {
    padding: 0.4rem 0.32rem;

    .popup-title {
      font-size: 0.48rem;
      font-family: DiDiSansPro-Bold;
      line-height: 0.56rem;
      color: #333333;
      font-weight: 700;
    }

    .popup-label {
      margin-top: 0.24rem;
      font-size: 0.28rem;
      font-family: DiDiSansPro-Regular;
      line-height: 0.32rem;
      color: #333333;
      line-height: 0.32rem;
      font-weight: 400;
    }

    .popup-confirm {
      margin-top: 0.8rem;
      height: 1.04rem;
      font-size: 0.4rem;
      font-family: DiDiSansPro-Bold;
      line-height: 1.04rem;
      color: #ffffff;
      text-align: center;
      font-weight: 700;
      background-image: linear-gradient(145deg, #ff7d41 0%, rgba(255, 116, 15, 0.75) 99%);
      border-radius: 0.2rem;
    }

    .popup-cancel {
      margin-top: 0.4rem;
      height: 1.04rem;
      font-size: 0.4rem;
      font-family: DiDiSansPro-Bold;
      line-height: 1.04rem;
      color: #333333;
      text-align: center;
      font-weight: 700;
      background-color: #e9ecee;
      border-radius: 0.2rem;
    }

    &.only-content {
      padding-top: 0.76rem;

      .popup-title {
        margin: 0 0.16rem;
      }

      .popup-label {
        margin: 0.24rem 0.16rem 0;
      }

      .popup-confirm {
        margin-top: 0.8rem;
      }
    }
  }

  .close-icon {
    height: 0.6rem;
    width: 0.6rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    background: url('@/assets/common/icon_close_popup.png') center / 100% no-repeat;
  }
}

.brstyle {
  .popup-content {
    .popup-confirm {
      color: #333333;
      background-image: linear-gradient(-46deg, #ffae1e 0%, #ffca00 100%);
    }
  }
}
</style>
